/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

let PluginTooltipster = new function(){
    let me = this;

    this.init = function(obj){
        obj.find('[data-plugin-tooltipster]').each(function (){
            let el = $(this);
            let options = el.data('plugin-tooltipster');

            let defaults = {
                theme: 'default',
                trigger: 'hover focus',
                html: true,
                delay: 200,
            };

            let settings = $.extend({}, defaults, options);
            settings.template = '<div class="tooltip tooltip-'+settings.theme+'" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>';

            el.tooltip(settings);
        });
    };
};

module.exports = PluginTooltipster;
